import { defaultSystemCode, SystemCode } from '@/api'

export interface UpdateOrderMemoOrderInfoItem {
  orderId: number
  buyBranchCode: SystemCode
  callNo: string
  shelfType: SystemCode
  collectionType: SystemCode
  status: SystemCode
  handlingType: SystemCode
  appendixCode: SystemCode
  updatedTime: string
  updatedBranchCode: SystemCode
}

export const defaultUpdateOrderMemoInfoItem: UpdateOrderMemoOrderInfoItem = {
  orderId: 0,
  buyBranchCode: defaultSystemCode(),
  callNo: '',
  shelfType: defaultSystemCode(),
  collectionType: defaultSystemCode(),
  status: defaultSystemCode(),
  handlingType: defaultSystemCode(),
  appendixCode: defaultSystemCode(),
  updatedTime: '',
  updatedBranchCode: defaultSystemCode()
}
